const SEPARATOR_TOKEN = /^[|\-–—:]+$/;
const LEADING_SEPARATORS = /^[|\-–—:]+/;
const PLATE = /^[A-Z]{2,3}-?\d{3,4}-?[A-Z]{0,2}$/;

const tokenize = (name: string): string[] => name.replace(/\|/g, " | ").split(/\s+/).filter(Boolean);

const dropTrailingSeparators = (tokens: string[]): string[] =>
  tokens.length > 0 && SEPARATOR_TOKEN.test(tokens[tokens.length - 1])
    ? dropTrailingSeparators(tokens.slice(0, -1))
    : tokens;

export const shortenName = (name: string): string => {
  const tokens = tokenize(name);
  if (tokens.length < 2) return name;
  const last = tokens[tokens.length - 1].replace(LEADING_SEPARATORS, "");
  if (!PLATE.test(last)) return name;
  const unit = dropTrailingSeparators(tokens.slice(0, -1)).join(" ");
  return unit || name;
};
